"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
// Based on an idea called "usePrevious" from the React team
function useWhenChanged(callback, prop, initialValue) {
    const [internalFormDataState, setInternalState] = (0, react_1.useState)(
    // 1
    initialValue !== null && initialValue !== void 0 ? initialValue : prop);
    const previousValueRef = (0, react_1.useRef)(); // 2
    const previousValue = previousValueRef.current;
    if (prop !== previousValue && prop !== internalFormDataState) {
        setInternalState(prop);
        callback(prop, previousValue);
    }
    (0, react_1.useEffect)(() => {
        // 3
        previousValueRef.current = prop;
    }, [prop]);
}
exports.default = useWhenChanged;
